import { ClientSectionSlot as BaseClientSectionSlot } from "../../common/components";
import SalesPersonSelect from "../../common/components/SalesPersonSelect";
import { Col, Form, Input, Row } from "antd";

export const ClientSectionSlot = ({ invoiceData, active, ...baseProps }) => {
    const form = Form.useFormInstance();
    const fiscalInvoiceType = Form.useWatch("Fiscal_Invoice_Type", form);

    return (
        <>
            <BaseClientSectionSlot {...baseProps} />
            <Row gutter={16}>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="Razon_Social"
                        label="Razón social"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                {fiscalInvoiceType === "Factura crédito fiscal" ? (
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="NCR"
                            label="NCR"
                            tooltip="Número de crédito tributario"
                            rules={[{ required: true, message: "Ingrese el NCR" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                ) : null}
            </Row>
            <SalesPersonSelect />
        </>
    );
};
